import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { CONFIG } from '../../../environments/config';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[featureToggle]'
})
export class FeatureToggleDirective implements OnInit {
    @Input() featureToggle: any;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) {}

    ngOnInit(): void {
        if (this.isEnabled()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    isEnabled(): boolean {
        if (this.featureToggle === true) {
            return true;
        }

        const { features } = CONFIG;
        if (features['*']) {
            return true;
        }

        return features[this.featureToggle];
    }
}
